import { useEffect, useRef } from 'react';
import type { Wallpaper } from '../types';
export function ArtMedia({
  item,
  motion = false,
  eager = false,
}: {
  item: Pick<Wallpaper, 'id' | 'title' | 'type'>;
  motion?: boolean;
  eager?: boolean;
}) {
  const video = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const element = video.current;
    if (!element) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && motion) element.play().catch(() => {});
        else element.pause();
      },
      { threshold: 0.1 },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [motion]);
  return (
    <>
      <img
        className="art-image"
        src={`/art/${item.id}.jpg`}
        alt={item.title}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
      />
      {item.type === 'dynamic' && motion && (
        <video
          className="art-video"
          ref={video}
          src={`/art/${item.id}.mp4`}
          poster={`/art/${item.id}.jpg`}
          muted
          loop
          playsInline
          aria-label={`${item.title}动态预览`}
        />
      )}
    </>
  );
}
